/**
 * Bundle Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Can from '../../components/Can';
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getBundleWithIdAction,
  updateBundleStatusActions,
} from '../bundles/actions';
import {
  getOrdersAction,
  updateOrderStatusActions,
  cancelOrderAction,
} from '../orders/actions';

import { DriverStreamLiveLocationRequestBuilder } from 'client-sdk/src/drivers/drivers';
import Client from 'client-sdk/src/client';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectBundle,
  makeSelectLoading,
  makeSelectError,
} from '../bundles/selectors';
import {
  makeSelectOrdersList,
  makeSelectLoading as makeSelectLoadingOrders,
} from '../orders/selectors';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Select,
  ClickAwayListener,
  IconButton,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountKeyOutline,
  mdiCardAccountPhoneOutline,
  mdiMapMarkerRadiusOutline,
  mdiCalendarClock,
  mdiStateMachine,
  mdiKeyOutline,
  mdiAccountOutline,
  mdiArrowRight,
  mdiCar,
  mdiPencilOutline,
  mdiMapSearchOutline,
  mdiPhoneOutline,
  mdiPackageVariant,
  mdiPaperRollOutline,
  mdiPrinter,
  mdiClose,
} from '@mdi/js';
import WebSoketClient from 'client-sdk/src/WebSoketClient';

// Components
import ListOrders from './list';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';

// Map
import MapTrackDriver from './MapTrackDriver';

// Helper
import {
  translate,
  removeEmptyValueObject,
  uintToString,
  formaterPhoneNumber,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Status } from '../bundles/interfaces';
import { Payload as PaylodOrder } from '../orders/interfaces';
import { SelectorProps, Props } from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import useQuery from '../../utils/hook/useQuery';
import windowSize from '../../utils/hook/useWindowResize';
import BundleDetailsMob from '../bundleDetailsMob';
import handleError from '../../utils/handleError';
import BundlesRepository from 'client-sdk/src/Repository/bundles-repository';

type Inputs = {
  'customerName.contains': string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        // margin: theme.spacing(3),
        // fontFamily: 'sans-font',
      },
    },
    paper: {
      marginTop: '0px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '12px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px',
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

// const
const bundleStatus = [
  'CREATED',
  'ASSIGNED',
  'PROCESS_STARTED',
  'PROCESSED',
  'VEHICLE_ARRIVED',
  'LOADED',
  'PROCESSED',
  'PROCESS_FAILED',
  'CANCELLED',
];

export function Details(props: Props) {
  const authContext = useContext(AuthContext);

  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 1000,
  } as any, '');
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openMap, setOpenMap] = useState(false as boolean);
  const [isMob, setIsMob] = useState(false);
  const [position, setPosition] = useState([35.6892, 51.389] as number[]);
  const [signatureModal, setSignatureModal] = React.useState(false as boolean);
  const [image, setImage] = React.useState(null);


  const [zoom] = useState(17 as number);

  const classes = useStyles();
  const { width } = windowSize();

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    if (!image) {
      getSignature()
    }
  }, [])


  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contais': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  useEffect(() => {
    const { id } = props.match.params;
    props.bundleWithIdDispatch(id);
    props.ordersDispatch({ 'bundleId.equals': id, ...filtersValues });
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام سفارش‌دهنده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'customerPhoneNumber.contains',
        label: 'شماره همراه سفارش‌دهنده',
        icon: mdiPhoneOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت سفارش',
        data: [
          'ORDERED',
          'DELIVERED_TO_POST',
          'DELIVERED_TO_CENTER',
          'SUPPLIED_IN_CENTER',
          'PACKAGED',
          'BUNDLED',
          'LOADED',
          'ARRIVED',
          'DELIVERED',
          'NOT_DELIVERED',
          'RETURNED',
          'CANCELLED',
          'SCANNED',
        ],
        translateType: 'Order',
        icon: mdiStateMachine,
      },
    ]);
  };
  let headCells = [];

  const handleCloseSignatureModal = () => {
    setSignatureModal(false);
  };
  const handleOpenSignatureModal = () => {
    setSignatureModal(true);
  }
  Can({
    role: authContext.user.role,
    perform: 'orders:list:centerName',
    yes: () => {
      headCells = [
        {
          id: 'customerName',
          label: 'نام سفارش‌دهنده',
          type: 'input',
        },
        { type: 'input', id: 'id', label: 'شناسه سفارش' },
        { type: 'input', id: 'partnerName', label: 'نام شرکت' },
        { type: 'input', id: 'centerName', label: 'مرکز سفارش' },
        {
          type: 'checkbox',
          id: 'status',
          label: 'وضعیت سفارش',
          data: [
            'ORDERED',
            'DELIVERED_TO_POST',
            'DELIVERED_TO_CENTER',
            'SUPPLIED_IN_CENTER',
            'PACKAGED',
            'BUNDLED',
            'LOADED',
            'ARRIVED',
            'DELIVERED',
            'NOT_DELIVERED',
            'RETURNED',
            'CANCELLED',
            'SCANNED',

          ],
          translateType: 'Order',
        },
      ];
    },
    no: () => {
      headCells = [
        { type: 'input', id: 'customerName', label: 'نام سفارش‌دهنده' },
        { type: 'input', id: 'id', label: 'شناسه سفارش' },
        { type: 'input', id: 'partnerName', label: 'نام شرکت' },
        { type: 'input', id: 'trackingCode', label: 'کد پیگیری' },
        {
          type: 'checkbox',
          id: 'status',
          label: 'وضعیت سفارش',
          data: [
            'ORDERED',
            'DELIVERED_TO_POST',
            'DELIVERED_TO_CENTER',
            'SUPPLIED_IN_CENTER',
            'PACKAGED',
            'BUNDLED',
            'LOADED',
            'ARRIVED',
            'DELIVERED',
            'NOT_DELIVERED',
            'RETURNED',
            'CANCELLED',
          ],
          translateType: 'Order',
        },
      ];
    },
  });
  const head = { headCells };
  const GetStreamLiveLocation = () => {
    const WSClient = new WebSoketClient().execute();
    const token = localStorage.getItem('token') || '';
    const client = new Client(token);
    const makeDriverLiveRequest = new DriverStreamLiveLocationRequestBuilder()
      .id(Number(props.bundle.driverId))
      .build();

    client.execute(makeDriverLiveRequest);

    WSClient.on('connect', function () {
      WSClient.subscribe('admdrvloc', function (err: any) { });
    });
    WSClient.on('message', function (topic: any, mes: any) {
      const parsMesage = uintToString(mes);
      if (parsMesage) {
        const { lat, lon } = parsMesage;
        setPosition([lat, lon]);
      }
    });
    setOpenMap(true);
  };

  const changeStatusBundle = () => {
    props.updateBundleStatusDispatch({
      id: props.bundle.id,
      body: previewState,
      pagination: {},
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
    setOpenMap(false);
  };

  const handleCancel = async (payload: {
    id: number;
    body: { description: string };
    pagination: any;
  }) => {
    await props.cancelOrderDispatch(payload);
    // props.bundleWithIdDispatch(props.match.params.id);
  };

  const getSignature = async () => {
    const { id } = props.match.params;
    try {
      const response = await BundlesRepository.getBundleSignature({ payload: { id } })
      setImage(response.data)
    } catch (err) {
      handleError(err)
    }
  }
  return isMob ? <BundleDetailsMob {...props} /> : (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <div className={classes.headerBox}>
            <Typography
              variant="h6"
              component="div"
              style={{ marginLeft: '20px', fontSize: '18px' }}
            >
              {` جزئیات مرسوله`}
            </Typography>
            <span className={classes.contentlabelTitle}>{props.bundle.id}</span>
          </div>
        </Grid>
        <Grid item xs={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 1000,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'customerName.contains',
              placeholder: 'نام سفارش دهنده',
            }}
            filterValues={filtersValues}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>
        <Grid container item xs={12} sm={6} direction="row-reverse">
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={GetStreamLiveLocation}
          >
            <Icon
              path={mdiMapSearchOutline}
              size={1}
              style={{ marginLeft: '10px' }}
            />
            {`مشاهده راننده روی نقشه`}
          </Button>
          <Can
            role={authContext.user.role}
            perform="/deliver/receipts/:id"
            yes={() => (
              <Link
                to={`/deliver-driver-receipt/${props.bundle.id}`}
                target="_blank"
                style={{ textDecoration: 'none' }}
              >
                <Button
                  style={{ marginLeft: '10px' }}
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<Icon path={mdiPrinter} size={1} />}
                >
                  چاپ رسید
                </Button>
              </Link>
            )}
          />
          <Button
            variant='contained'
            color='secondary'
            aria-label="signature"
            title="نمایش امضا"
            size="small"
            onClick={handleOpenSignatureModal}
            style={{ marginLeft: "4px" }}
            disabled={!props.bundle.signatureFileUUID}
          >
            امضای راننده
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`نام راننده:  `}
                  </span>

                  <span>{props.bundle.driverName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCardAccountPhoneOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`شماره تماس راننده:  `}
                  </span>

                  <span>
                    {formaterPhoneNumber(props.bundle.driverPhoneNumber)}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`شناسه راننده:  `}
                  </span>

                  <span>{props.bundle.driverId}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCar} size={1} className={classes.icon} />
                    {`نوع وسیله نقلیه:  `}
                  </span>

                  <span>{props.bundle.vehicleClass}</span>
                </div>
              </Grid>
              <Divider className={classes.divider} />
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerRadiusOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`نام مرکز:  `}
                  </span>

                  <span>{props.bundle.centerName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                    {`زمان تحویل:  `}
                  </span>

                  <div>
                    <span>
                      {props.bundle.deliveryDate &&
                        `${jMoment(props.bundle.deliveryDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                    &nbsp; &nbsp;- &nbsp; &nbsp;
                    <span>
                      {props.bundle.deliveryStartTime &&
                        jMoment(props.bundle.deliveryStartTime, 'hh:mm:ss')
                          .locale('fa')
                          .format('HH')}
                      {'تا '}
                      {props.bundle.deliveryEndTime &&
                        jMoment(props.bundle.deliveryEndTime, 'hh:mm:ss')
                          .locale('fa')
                          .format('HH')}
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`شناسه مرسوله:  `}
                  </span>

                  <span>{props.bundle.id}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`تعداد سفارش:  `}
                  </span>

                  <span>{props.bundle.ordersCount}</span>
                </div>
              </Grid>
              <Divider className={classes.divider} />

              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPaperRollOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'توضیحات:  '}
                  </span>
                  <span>
                    {props.bundle.description && props.bundle.description}
                  </span>
                </div>
              </Grid>
              <Divider className={classes.divider} />
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiStateMachine}
                      size={1}
                      className={classes.icon}
                    />
                    {`وضعیت:  `}
                  </span>

                  <span>
                    <FormControl style={{ width: '100%' }}>
                      <Icon
                        path={mdiPencilOutline}
                        size={1}
                        className={classes.changStatusIcon}
                      />
                      <Select
                        className={classes.changStatusBox}
                        fullWidth
                        name={`status`}
                        multiple
                        id={props.bundle.status}
                        value={[{}]}
                        IconComponent={() => null}
                        renderValue={() => (
                          <span className={classes.renderValue}>
                            {translate(props.bundle.status, 'bundle')}
                          </span>
                        )}
                      >
                        <RadioGroup
                          className={classes.radioGroup}
                          aria-label={`status`}
                          name={`status$`}
                          value={'item'}
                          onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
                            handleOpenConfirmUpdateState(
                              `${e.target.value}` as Status
                            )
                          }
                        >
                          {bundleStatus.map((item: any, index: number) => (
                            <FormControlLabel
                              className={classes.radioGroupItem}
                              key={index}
                              checked={props.bundle.status === item}
                              value={item}
                              control={<Radio />}
                              label={translate(item, 'bundle')}
                            />
                          ))}
                        </RadioGroup>
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>
            </Grid>
          </Paper>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                props.ordersList && (
                  <ListOrders
                    data={props.ordersList}
                    updateOrderStatusDispatch={props.updateOrderStatusDispatch}
                    cancelOrderDispatch={handleCancel}
                    bundleId={props.bundle.id}
                    loading={props.ordersListLoading && props.loading}
                    head={head}
                    filterVal={filtersValues}
                    onFilterValue={(filtervalues: any) => {
                      setFiltersValues({
                        ...removeEmptyValueObject(filtervalues),
                        ...filtersValues,
                        page: 0,
                        size: 10,
                      });
                    }}
                    removeFilterHandler={removeFilterHandler}
                    filterLabelTranslator={filterTranslator}
                  />
                )
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={signatureModal}
        fullWidth
        onClose={handleCloseSignatureModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '5px',
              top: '5px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseSignatureModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div>
            {image && <img width="100%" src={image} alt="signature" />}
          </div>
        </DialogContent>
        {/* <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseSignatureModal}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                // onClick={handleUploadBundles}
                size="large"
              // disabled={loading}
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions> */}
      </Dialog>
      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle />
        <DialogContent>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت مرسوله
        "${translate(props.bundle.status as Status, 'bundle')}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'bundle')}"
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={changeStatusBundle}
                color="primary"
                variant="outlined"
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openMap}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          {' '}
          <MapTrackDriver position={position} zoom={zoom} />
        </DialogContent>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  bundle: makeSelectBundle(),
  ordersList: makeSelectOrdersList(),
  ordersListLoading: makeSelectLoadingOrders(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    bundleWithIdDispatch: (id: number) => dispatch(getBundleWithIdAction({ id })),
    updateBundleStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateBundleStatusActions(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    ordersDispatch: (payload: PaylodOrder) =>
      dispatch(getOrdersAction(payload)),
    cancelOrderDispatch: (payload: { id: number; body: { description: string } }) =>
      dispatch(cancelOrderAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
